import React from "react";

function Accesoriess({ type }) {
    if (type === 2) {
        return (
            <div class="z-0 mx-auto max-w-screen-2xl animate-pulse -mr-20">
                <div class="flex justify-end">
                    <svg width="269" height="359" viewBox="0 0 269 359" fill="none" class="lg:absolute z-0 -mt-48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="153.055" cy="115.055" r="115.055" fill="#1C3970" />
                        <circle cx="95.1417" cy="199.142" r="95.1417" fill="#34B3FF" />
                        <circle cx="174.945" cy="278.937" r="79.6535" fill="#96F2FF" />
                    </svg>
                </div>
            </div>
        );
    }
    return (
        <div class="z-0 mx-auto max-w-screen-2xl animate-pulse -ml-20">
            <div class="flex justify-start">
                <svg width="269" height="359" viewBox="0 0 269 359" fill="none" class="absolute z-0 -mt-16" xmlns="http://www.w3.org/2000/svg">
                    <circle r="115.055" transform="matrix(-1 0 0 1 115.945 115.055)" fill="#1C3970" />
                    <circle r="95.1417" transform="matrix(-1 0 0 1 173.858 199.142)" fill="#34B3FF" />
                    <circle r="79.6535" transform="matrix(-1 0 0 1 94.055 278.937)" fill="#96F2FF" />
                </svg>
            </div>
        </div>
    );
}

function About() {
    return (
        <React.Fragment>
            {/* Creator section */}

            <main className="">
                <div className="main-container font-poppins overflow-hidden lg:w-3/4 mx-auto">
                    <section id="creator" className="pt-40 flex flex-col lg:flex-row">
                        <div class="mx-auto max-w-screen-2xl z-40 pb-32">
                            <div class="relative z-10 text-4xl font-bold font-mono  leading-tight text-center heading text-white md:text-4xl lg:text-5xl lg:leading-snug">Meet the creators</div>
                            <div class="grid items-center mt-14 md:grid-cols-12">
                                <div class="md:col-span-4">
                                    <img src="./img\creator-edric.jpg" alt="user" class="rounded-2xl w-1/3 md:w-4/6 mx-auto lg:mx-0" />
                                </div>
                                <div class="md:col-span-8  text-slate-400 text-center md:text-left px-8 lg:px-0 lg:col-span-6">
                                    <p class="text-md lg:text-xl my-8 lg:mb-8 lg:my-0 font-normal text-white-2">
                                        "Created this website with the aim that people can express what is in their hearts such as feelings of love, doubts, problems and others without thinking that anyone will know them. "
                                    </p>
                                    <div class="username">
                                        <div class="font-semibold text-white text-xl lg:text-2xl">Edric Galentino</div>
                                        <span class="text-lg lg:text-xl font-normal text-gray-200">Developer</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Accesoriess type={2} />
                    </section>
                </div>
            </main>
        </React.Fragment>
    );
}

export default About;
